import { TAMobile } from "./TAMobile";


function EducationMobile() {
  return (
    <section
      id="teaching"
      className="pt-[85px]"
    >
      <div className="container items-start">
        <div className="flex items-center">
          <p className="text-xl font-bold mb-8">TEACHING</p>
        </div>
        <TAMobile />
      </div>
    </section>
  );
}

export default EducationMobile;
